import { count_words } from './count_words';
import { ignored_words } from './ignored_words';
export function parse_text_to_words(text, title) {
    let no_title;
    title.split(' ').forEach((word) => {
        const title_re = new RegExp(word, 'g');
        no_title = text.replace(title_re, '');
    });
    const re_words = /(\w|')+/g;
    return no_title.match(re_words);
}
export function get_word_list(page, answer_title, puzzle) {
    const words = parse_text_to_words(page.extract, answer_title);
    const word_counts = count_words(words);
    //@ts-ignore
    const word_counts_array = [...word_counts.entries()];
    const filtered_words = word_counts_array.filter(el => ![...puzzle.answers, ...puzzle.remove, ...ignored_words].includes(el[0]));
    const split_answer = puzzle.name.split('_');
    const removed_answer = filtered_words.filter((el) => {
        for (let word_in_answer of split_answer) {
            if (word_in_answer.length < 4) {
                continue;
            }
            const regex = new RegExp(`${word_in_answer.toLowerCase()}`);
            if (regex.test(el[0])) {
                return false;
            }
        }
        return true;
    });
    let truncated;
    if (removed_answer.length > 144) {
        truncated = removed_answer.slice(0, 144);
    }
    else {
        truncated = removed_answer;
    }
    truncated.sort((a, b) => b[1] - a[1]);
    return truncated;
}
